import * as React from 'react';
import ReactDOM from 'react-dom/client';

import { isConsentCategoryDisabled } from '@/tscapi/utils/consent';

import TrueFitCart from './truefit-cart.component';

/* prevent truefit if functional consent disabled */
{
    !isConsentCategoryDisabled('functional') &&
        document.addEventListener(
            'tf-ready',
            function (e: CustomEvent) {
                const checkExist = setInterval(function () {
                    const truefitCartElement = document.getElementById('tf-cart-wrapper') as HTMLElement;
                    if (truefitCartElement != undefined) {
                        const root = ReactDOM.createRoot(truefitCartElement);
                        clearInterval(checkExist);
                        root.render(
                            <React.StrictMode>
                                <TrueFitCart detail={e.detail} />
                            </React.StrictMode>,
                        );
                    }
                }, 100); // check every 100ms
            }.bind(this),
            false,
        );
}
